"use client";

import dynamic from "next/dynamic";

const SupportChatWidget = dynamic(
  () => import("./SupportChatWidget").then((module) => module.SupportChatWidget),
  { ssr: false },
);

/**
 * Public-site chrome. The widget used to be suppressed on `/packs/[slug]/open`
 * because that route was only the rip; the pack page lives there now, so the
 * launcher is hidden for the length of a ceremony instead — see
 * `[data-mot-rip-active]` in globals.css.
 */
export function SupportChatShell() {
  return <SupportChatWidget />;
}
